export const AGE_GATE_VERSION = '2026-09-20';
export const AGE_GATE_CONFIRMED_KEY = `privaposts_age_confirmed_${AGE_GATE_VERSION}`;
export const AGE_GATE_DENIED_KEY = `privaposts_age_denied_${AGE_GATE_VERSION}`;

export const AGE_GATE_LEGAL_PATHS = [
    '/terms',
    '/privacy-policy',
    '/complaints-content-removal-appeals',
    '/anti-human-trafficking-policy',
    '/2257-compliance',
    '/creator-content-provider-agreement',
];

export const AGE_GATE_PUBLIC_PATHS = [
    '/',
    '/login',
    '/register',
    '/how-it-works',
    '/weddings',
    '/referrals',
    '/india-payments',
    '/help/priva-balance',
    '/logos',
    '/faq',
    '/verify',
    '/social-media-influencer-creator-guide',
    '/blog',
    '/blog/why-private-sharing-matters',
    '/blog/every-life-has-a-story-worth-celebrating',
    '/blog/weddings-families-and-moments-worth-protecting',
];

const RESTRICTED_SINGLE_SEGMENT_PATHS = [
    '/home',
    '/followers',
    '/following',
    '/catalogue',
    '/marketplace',
    '/priva-balance',
    '/payment-details',
    '/shared-media',
    '/promotion',
    '/edit-profile',
    '/settings',
    '/creator-dashboard',
    '/stash',
    '/creator-support',
    '/messages',
    '/become-creator',
    '/create',
    '/my-referrals',
    '/add-account',
    '/performance',
    '/welcome-messages',
    '/user-lists',
    '/my-notification',
    '/administration',
    '/live-test',
];

const PUBLIC_DYNAMIC_PATHS = [
    /^\/password\/reset\/[^/]+$/,
    /^\/trial\/[^/]+$/,
];

export const isAgeGateExemptPath = (pathname, isAuthenticated = false) => {
    if (AGE_GATE_LEGAL_PATHS.includes(pathname)) return true;
    if (!isAuthenticated && AGE_GATE_PUBLIC_PATHS.includes(pathname)) return true;
    if (!isAuthenticated && PUBLIC_DYNAMIC_PATHS.some((pattern) => pattern.test(pathname))) return true;

    return !isAuthenticated
        && /^\/[A-Za-z0-9_-]{2,20}$/.test(pathname)
        && !RESTRICTED_SINGLE_SEGMENT_PATHS.includes(pathname);
};

export const getAgeGateState = (pathname, session = window.sessionStorage, persistent = window.localStorage, isAuthenticated = false) => {
    if (isAgeGateExemptPath(pathname, isAuthenticated)) return 'exempt';
    if (persistent.getItem(AGE_GATE_DENIED_KEY) === 'true') return 'denied';
    if (session.getItem(AGE_GATE_CONFIRMED_KEY) === 'true') return 'confirmed';
    return 'unknown';
};

export const confirmAdultVisitor = (session = window.sessionStorage) => {
    session.setItem(AGE_GATE_CONFIRMED_KEY, 'true');
};

export const denyUnderageVisitor = (session = window.sessionStorage, persistent = window.localStorage) => {
    persistent.setItem(AGE_GATE_DENIED_KEY, 'true');
    session.removeItem(AGE_GATE_CONFIRMED_KEY);
};
